import { Button } from '@/components/ui/button.js';
import { RightDrawer } from '@/components/ui/right-drawer.js';
import { type CoachPoolWithMatchCount } from '@airreading/common/data';

import { CoachPoolList } from './coach-pool-list.js';

interface CoachPoolDrawerProps {
  pools: CoachPoolWithMatchCount[];
  poolsLoading: boolean;
  poolsError: boolean;
  drawerOpen: boolean;
  onDrawerOpenChange: (open: boolean) => void;
  onViewPool: (pool: CoachPoolWithMatchCount) => void;
  onCreatePool: () => void;
  onSavePool?: () => void;
  onCancelCreate?: () => void;
  saveDisabled?: boolean;
  isPoolFormOpen?: boolean;
  showTriggers?: boolean;
}

// Drawer to manage the coach pools
export const CoachPoolDrawer = ({
  pools,
  poolsLoading,
  poolsError,
  drawerOpen,
  onDrawerOpenChange,
  onViewPool,
  onCreatePool,
  onSavePool,
  onCancelCreate,
  saveDisabled = false,
  isPoolFormOpen = false,
  showTriggers = true,
}: CoachPoolDrawerProps) => {
  const showActionButton = showTriggers || isPoolFormOpen;

  return (
    <>
      {showActionButton && (
        <div className="flex items-center gap-2">
          {showTriggers ? (
            <Button
              type="button"
              variant="outline"
              data-testid="teachers-availabilities-button-manage-pools"
              onClick={() => onDrawerOpenChange(true)}
            >
              Manage pools
            </Button>
          ) : null}
          {isPoolFormOpen && onCancelCreate ? (
            <Button
              type="button"
              variant="dismiss"
              data-testid="teachers-availabilities-button-cancel-create-pool"
              onClick={onCancelCreate}
            >
              Cancel
            </Button>
          ) : null}
          <Button
            type="button"
            size={showTriggers ? 'default' : 'sm'}
            data-testid={
              isPoolFormOpen ? 'teachers-availabilities-button-save-pool' : 'teachers-availabilities-button-create-pool'
            }
            disabled={isPoolFormOpen && saveDisabled}
            onClick={isPoolFormOpen ? onSavePool : onCreatePool}
          >
            {isPoolFormOpen ? 'Save changes' : '+ Create new pool'}
          </Button>
        </div>
      )}
      <RightDrawer
        open={drawerOpen}
        onOpenChange={onDrawerOpenChange}
        title={<div className="text-[30px] font-semibold">Manage pools</div>}
        widthClass="sm:max-w-4xl bg-[#F7F7F9] py-0"
        contentClassName="pt-0"
      >
        <CoachPoolList pools={pools} isLoading={poolsLoading} isError={poolsError} onViewPool={onViewPool} />
      </RightDrawer>
    </>
  );
};
